import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useShelfContext } from "../../../context/ShelfContext";
import "../NewShelf/newShelf.css";

const UpdateShelf = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    description: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [selectedShelf, setSelectedShelf] = useState(null);

  const { shelves, isFetching, updateShelf } = useShelfContext();

  // ✅ تحميل بيانات الرف عند فتح الصفحة أو تغيير الـ ID
  useEffect(() => {
    if (id && shelves.length > 0 && !isFetching) {
      const shelf = shelves.find((s) => s.id === parseInt(id));
      if (shelf) {
        setSelectedShelf(shelf);
        setFormData({
          id: shelf.id,
          name: shelf.name,
          description: shelf.description || "",
        });
        // ✅ امسح الرسائل فقط لما يتغير الرف
        if (selectedShelf?.id !== shelf.id) {
          setError("");
          setMessage("");
        }
      } else {
        setError("الرف غير موجود");
        setMessage("");
      }
    }
  }, [id, shelves, isFetching]);

  const handleSelectShelf = (shelf) => {
    // ✅ تغيير الـ URL عند اختيار رف
    navigate(`/update-shelf/${shelf.id}`);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!formData.id) return setError("يرجى اختيار رف للتحديث");
    if (!formData.name.trim()) return setError("اسم الرف مطلوب");

    setIsLoading(true);
    const result = await updateShelf({
      id: formData.id,
      name: formData.name,
      description: formData.description,
    });

    if (result.success) {
      setMessage(result.message);
    } else {
      setError(result.message || "حدث خطأ أثناء التحديث");
    }
    setIsLoading(false);
  };

  return (
    <div className="shelf-page">
      {/* ✅ عرض الرفوف */}
      <div className="shelf-list">
        <h2>📚 الرفوف الحالية</h2>
        {isFetching ? (
          <p className="loading-text">جارٍ التحميل...</p>
        ) : shelves.length === 0 ? (
          <p className="no-shelves">لا يوجد رفوف بعد</p>
        ) : (
          <ul>
            {shelves.map((shelf) => (
              <li
                key={shelf.id}
                onClick={() => handleSelectShelf(shelf)}
                className={selectedShelf?.id === shelf.id ? "selected" : ""}
              >
                <p>
                  الرف: <strong>{shelf.name}</strong>
                </p>
                <p>
                  الوصف:{" "}
                  <span>
                    {shelf.description ? shelf.description : "لا يوجد"}
                  </span>
                </p>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* ✅ الفورم */}
      <div className="card-parent">
        <div className="new-shelf-card">
          <div className="new-shelf-header">
            <h1 className="new-shelf-title">تحديث رف</h1>
            <p className="new-shelf-subtitle">
              اختر رف من القائمة ثم عدل معلوماته واضغط على زر التحديث
            </p>
          </div>

          <form className="new-shelf-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name" className="form-label">
                اسم الرف <span className="required">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                className="form-input"
                placeholder="أدخل اسم الرف"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={!selectedShelf}
              />
            </div>

            <div className="form-group">
              <label htmlFor="description" className="form-label">
                الوصف
              </label>
              <textarea
                id="description"
                name="description"
                className="form-input"
                placeholder="أدخل وصفاً اختياريًا"
                value={formData.description}
                onChange={handleChange}
                rows="3"
                disabled={!selectedShelf}
              ></textarea>
            </div>

            {error && <p className="error-message">{error}</p>}
            {message && <p className="success-message">{message}</p>}

            <button
              type="submit"
              className={`submit-button ${isLoading ? "loading" : ""}`}
              disabled={isLoading || !selectedShelf}
            >
              {isLoading ? (
                <div className="loading-spinner"></div>
              ) : (
                "تحديث الرف"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateShelf;
